
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["liquid-demo-common","liquid-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Liquid__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Liquid/index.en.md?type=demo')
};